import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Container
} from '@chakra-ui/react'
import HTMLWrapper from 'lib/html-wrapper'

const FAQLayoutTwo = ({ data, meta, theme, brandColor }) => {
  if (!data.length) {
    return false
  }

  const titleNode = () => {
    if (!meta.title) return false

    return (
      <Box
        as='h2'
        color={theme.sectionTitleColor}
        fontFamily='heading'
        fontSize='sectionTitle'
        fontWeight='heading'
        mb={4}
      >
        {meta.title}
      </Box>
    )
  }

  return (
    <Box
      bg={theme.backgroundColor}
      px={[2, 4, 8, 16]}
      className='faq-accordion'
    >
      <Box bg={theme.backgroundColor}
        py={8}
        px={[4, 4, 0, 0]}>
        <Container
          maxW='container.lg'
          mx='auto'>
          {titleNode()}
          <Accordion
            boxShadow='site'
            rounded='site'
            allowToggle
            allowMultiple
            color={theme.textColor}
            bg={theme.cardBackgroundColor}>
            {data.map((faq) => {
              return (
                <AccordionItem key={faq.id} border='none'>
                  <AccordionButton p={5}>
                    <Box
                      color={theme.textColor}
                      fontFamily='heading'
                      fontWeight='heading'
                      fontSize='heading'
                      flex='1'
                      textAlign='left'
                      wordBreak='break-word'
                    >
                      {faq.question}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel
                    color={theme.textColor}
                    fontFamily='body'
                    fontWeight='body'
                    fontSize='body'
                    pb={4}
                    pl={6}
                    wordBreak='break-word'
                    className='faq-editor'>
                      <HTMLWrapper html={faq.answer} />
                  </AccordionPanel>
                </AccordionItem>
              )
            })}
          </Accordion>
        </Container>
      </Box>
      <style jsx global>{`
            :global(.faq-editor ul) {
              padding-inline-start: 40px !important;
            }
            :global(.faq-editor a) {
              color: ${brandColor} !important;
            }
            }
          `}</style>
    </Box>
  )
}

FAQLayoutTwo.propTypes = {
  data: PropTypes.array,
  meta: PropTypes.object,
  theme: PropTypes.object,
  brandColor: PropTypes.string.isRequired
}

export default FAQLayoutTwo
